module.exports = __webpack_public_path__ + "img/schemeList09-3.20411ba0.png";